"use strict";

var React = require('react'),
    BS = require('react-bootstrap'),
    cx = require('classnames'),
    _ = require('underscore'),
    $ = require('jquery'),
    Constants = require('../../constants'),
    ProjectDetail = require('./ProjectDetail');

require('mapbox-leaflet-markercluster');

var ProjectsMap = React.createClass({displayName: "ProjectsMap",
    map: undefined,
    pinLayer: undefined,
    markersLatLon: undefined,
    centerPinLayer: undefined,

    getDefaultProps: function() {
        return {
            collection: undefined,
            id: '',
            onPositionChange: undefined,
            geoQuery: undefined,
            zoom: undefined,
            latitude: undefined,
            longitude: undefined,
            latitudeLink: undefined,
            longitudeLink: undefined,
            readOnly: false,
            useClusters: false,
            updateLatLong: true,
            updateLocation: false,
            wrapperClassName: 'widget-map-wrapper',
            precision: 4,
            markers: {
                "default": "data:image/png;base64,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",
                "empty": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAxCAYAAAC/BXv3AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NTA1MDAwNTA5Q0Y2MTFFNUEyQUZBQUI3OUZCQkEzMTQiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NTA1MDAwNTE5Q0Y2MTFFNUEyQUZBQUI3OUZCQkEzMTQiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo1MDUwMDA0RTlDRjYxMUU1QTJBRkFBQjc5RkJCQTMxNCIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo1MDUwMDA0RjlDRjYxMUU1QTJBRkFBQjc5RkJCQTMxNCIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PnPO75UAAAfLSURBVHjatFlrbFxHFf5m3+vNvrKO7aQxoakqkVCBmqpECn0IoYKIIFUSKgiVCqhgCYEETdSmqpqC+EPcAgJFBawk8CdV2tImVCBcRcJJK5RSk9Zp5VZNE1tR7DpOba9vvet93nuHc+Y+vI693keWkT+v996553xzzjdnZq6F99gVNNA2EnYQthE+Q1hPSBBKBI1wiXCeMEA4RcjWMqg/2K0+fZA1nQvC/YRHCHfTNwH7p6IFCZ0KEl8E5I/pk0kcJzxDuFjLCRFZkcnthD+S062LnUvUHIDAKurzQ7L/ffr2LOGpp6demlvacW9NIhyBXgjhr3TuoV+bjTQ2eTJY7ysh5pXURWAeXkwYIbxnRPCujMN0WAvl46f02PbH2nfveXr65beWjYhYysNL+AOhR7ItaREIyiJ2yjF8OayhIxlCW1sbQqEIAoEAvF6vetAwDJRK85jOafinFsSxXAp56Xfs3kq+Xtuf2v1A78zL/UtTYy5hcohG0aMyYd/aZlzFd8PjWJeMIpG4CbFYDJHIAgmPx6P6maapyKwrlXDL/Dy+qaXx2/EgTuXjTlAjhL/tT+76Wu/siYGVNMIJ+5G00yDo1x45ip3JLNrbu5BKpYhIQkWDSfh8PkWCU6P8kC0mo+s64vE49c3hmYSGTSOz+P10jKypfgEhxYn9iZ1berWTo66kfIdHnL+3EN6QHhlwpkoPPsBXUjq6urrQ0dGhSITDYfj9/kUErm8OoXK5jHw+D03T8MKlT3BgLGppnAcpxSAHu/yDjYaKiLQiIpQuBJGwU7UdY7ivvYy1a9cpIslkUpHgVFQj4I6O7jsp46gxvkPfL+c/wZGPQzZZ8QXq2aNmJXgSsGNT7qAhbIVpcKLRaWTx7diMikJnZydWr16t0sEGa5G4nhA/w8+yjUc/F8MtgbLyAWmy3wO+vkthi4iaFXIfXbVniMSD/itYszpJumhXuXYi0WzjZ9lGKhHHE7d6bT/sz1hLf+9RRIQpbybcRRfVzTVyHlsThhoBk+DROLPiRhrbYFtf3ZjAhqDliwdPvh9yIrKdSAhh8kUT93jTiNP0jEajTaWjVpoiZPOBdV5Y/piQvMv/7IU4a+RupQ3DVLgtmFM1wqkTrYhGZVTY5j1dYdcf+fYSh21MZLMlUiVa3NxmqnwGg0E1glY3tvnZjjbXnxKuKTdRZTW7JQvVmkKIB30uiVakZLkUJcJUkQUVPsNZR8V6LvFRipGlbmEohTs1oJVpqUyPShENWneXFxljIiUBU81lwyp6ivX/IxoVYUGhZNhrGQ9Wljg1c6TcMFPg6zNFjyrPXHEZrSbENicyJUjdXNjbCFNjWVxcEI2JD2lfxYsWr6JSypYHg22+czXr+lPFzcSIh6bQeaVV+8Y5zYtCoUD7ipKKTKsb2zw1qi0QMQRP43d4+p6G6XHn9euaH9NzOUWGV89WRoVtpbMFvPjhnO2PoyE04jDERF6F6c1YDA2UdYmXRgqYp41NsVhsaVTY1pHBj5AvlmHVLg/XkBPlp7YYrMwc4XmYPjdcx8YELkzMIpvNtixFbGN0KoNfvTFRoQ8vfx6u3Ab0QgZ0FSoKmV6WePLNLCan04oMi/dGUsTPZgpFfO+v76FQ1O3SzgP3nCn/8s7/2EQUuxHCIfBG12Z7YU7i0X9NYnJqRpFpVi/8zHy+iIePv4vBj5zZwtsAWoJNc59b6ARFwcbPhRm4qJjawv33pIGev1/BxbFryGQySjM8rett3HdyNovdf3kLr3yQrljoAuzv173tZ992iSwsPpIEK78lZDhn5c5QOPdxCTteGMVzZy9hJj2LXC6ndFOtzvA1vlcg0i8OXsadvzuLgdFZ1x5JgHekA+TryZWOE0N8thWI/IMMhkBnGW7pPLBv4Br63k7joc+nsP22LnS3x9xdfOVx4tpcAf3Dkzg8OIHhqdx1pb2NFrnQeWK76+BNb+qLbvl/9vpyUb2XcFKauSRkftmwf5qWqc1rwoiHrQNUpmjg/ak8RrVSldUuQstF6DT9tetg93819/yyd2/VAxa31wh3CISPk3q2KjJysTYuk8PL1ZwuGmoIwrOK8kiHcSkPHNxwTl+2m/8nZ1ZctdXxBvgFkemUZraB+ULbQU8bEzljH9yGlutVOnQvKqdvNZiEPxE20HQbsmaUUReEDLIwH6dnv0QYqupjmVmzEop8BiGhoQZxG7x1CE3QM7+paXuFQ3i1Rid4OvAY4lPOjq56VtSe9Ai/EKp752aV9bpAR315FHVERciI1bceuw2mxsGfqcboKxLhM7wp+wlX6rLZJJFxdiKUsyrRQJj79dVtc0EjDS/xfUD4GzDzy7w2o9nuCYzTcbK/4fNOA2J12qtAcIxmRvcS0VL1JHtHGxHpQmrsNwANgFe7o0KEl6ZGRNW9huw1qRFXtEDUWDxTXJGONWTrBiLCGCP0q+rpGPSs4ut9DdtyX2+aTW8B+0gTX5flHL+J45KuyDV9OEfzREi0oXEB73reZ9giNZo11mxqGLoSJtUNIWJ6wyJtkVgd0OyJm7ZIx5uysfDCt/7wlV7ZyduxDYQ1hBi/vPXfd/S8cXVw2Bzu20Xf6eSEed6wESYYgftPyvo00phEUoTNNpEo/3tEH37unLx6mglssguZQ4T/jzND9gv1GP6fAAMAIK0hwmgNzVQAAAAASUVORK5CYII=",
                "LEVEL1": "data:image/png;base64,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",
                "LEVEL2": "data:image/png;base64,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",
                "LEVEL3": "data:image/png;base64,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",
                "LEVEL4": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAxCAYAAAC/BXv3AAAACXBIWXMAAAsTAAALEwEAmpwYAAABhmlDQ1BQaG90b3Nob3AgSUNDIHByb2ZpbGUAAHjarZGxSiNRFIa/m8RVMWBYglqIXFDEYiLRLTTRJkYwioVEhSTdZDLGhUlymVxRH8DORgvRRlFfQbSxsBQLLQRBCD6DIAgiMhZTTLPsNvtV3/mLw+H8ENKmUk4EqNW1m5+bkYViSba36CLKT9L0mlZTZZaWFvkzAt6fEACPCVMpZ23+43l6Z/Pk4sfC0UBaG/ydrordtEB0AFaladVAOIBhKVeDOAQSm1ppELdA3C0USyBaQLzq+ysQLxeKJQhFgLi7ks9CqA+IlX0fAWJV3yeBmLVuViCUAwz/BgA6c7NyIplKZPjP1JwNK/gZUbu+ugzEgH5yzCKZIEmKBBltb2mAbENtu7+r61pmlHJsmW3U1Ia2XUPO161RQ44nx5IAhWJJ+qvf8ghA9DwEWeMUUoMQ3g2y8gFcXUPfXZANHUP3FFzeK9M1g4bfI/+am2u/xn2PzkDbi+e9DUP7Pnzted7nmed9nUO4BTfONyaoaeGNvFbIAAAAIGNIUk0AAG2YAABzjgAA9jMAAIFAAABwbgAA42IAADF4AAATcpTB5EwAAAj0SURBVHjatJh7cNTVFcc/97fv7CabhCQLJpSXCNrOVNGCBTMCPqgOjynKVO1j6kyjo05b333Y+GCqVhGcFrSlNGhbW2071VIY4msQlKkvFGqZEUhEBxKEBEOSTbLZZH/n9I/fPrJhN9mk9k7uTGbvved8fud877n39zP89jBjaNOB5cB8YDZQA5QCA0An0AzsA3YALwM9oxnUumkAuNFRnRtgBXAbUIvBkPwb0nxABIigLAC9BaUHeBZYAzSN5sSNjkhyHvBrDPOynSujPoAhhFKH6vXAE8C9q9tmdOeIyaggtwGPYIxnqHM3A8y032KmtYdq92FKXF0YA72EOWZP56B9AQf0QhJ4U0BuVH+IcuW9lc3Xrm4/872cETGng7iAJ4Eb1ADqAAS1g8t0E5cE/sbE8i6CQQgEwOsFt9tZmEjAwAC09YbZ1rGKf/TVEdXylN2ZRtl1X0XTqgdOzmw8LYBmw6Hhvz2J4aahGviK/QLfCjxITXk35eUQDkMoBD6fA2FZzjwRByYeh54eaO0oYe2Re9gZ+3omC8oAcMUDHWftAKiv1yTI+oNDIW4H1mKcQQubFbqGlWVPU1UFlZVQXg7BoAPh8TgQJgmt6sAMDjowvb3Q0QEbD32XTe13IbiSE00XMOeBU7MOZ0B+eSAFMQd4E0u9TmqVb/MjvlaxlTPOgIkTMxBebzbAafJLAg0MZGD+eGAZDx15BMUkI2PeAebLD2bZzkOrgqpB9UkQLyIgwmLZxJIJW6muhpoaiESclPj94HLlh3Cezpnj9ztrIhG4/ktbua5yk0OoAipzUb0htcZCFESXIzIPsUGEiH2Ia0rWE4nApElQUeFEwuPJBnjzg4msuvMKtr0+NS+Qx+OsraiAe+asZ6r3UAZGtN56/MPAUJA7UAcCEVZ61hGpSBCJOOkoKsrsjFR74/0zuHH1Iv65cxo3P7iQrbum5S9WbsdG1YQEd81el/Rjg9iTEL0WwDKi04zoRagNKlTqx1xYupsJE6CszHkalyvb8KtvTeZ79y/m4CdlAJz4rIibfr6Qv786Iy+My+XYWn7Wbib7P3Yigo0R/U5SI3IlmjBGBCPCXPd2SsNKOJw7HVt3TaNu9WI+OVaS5aj9VIDvP3wxf9o+a8Q0hYLK8urtOP5sULnI9eh/whaitYgNtoAtfNH3LqFQpk6kagTAX16ayc0PXsyxtmBOZ591+bl9zUU8teXsnOOW5dhcWP1u2h9iuxCd70b0HLDTNX96UTPBoKP4obr4w9bZ3P34Ak51+0Y8YjqjPu5et4CBQRc3Xr0/p16+PLHZ0YlTBgFztoXI5NRu8UiMUn80q1gBPPb787j10dpRIVKtu9fL3esW8HDDBTmjMiEYxWdiQ0QrNZYRLU4qGJf243JlynYKpLvXy4pFH1NZHisIpLIsxlWXNtMbc+cEsSzw0J/aORjREjeiAwYJAAziQzEYo1kCXX3z27S2hdjfXE57R6AgkNW3vE1NpCdvxesf8GFUAAvQATci3agGQBEMJ+NViJxIFtzMjrFtQyKRUW5pcZwpk6K4XIptG44cL06nzhaDbZu85f9oVxV2wiT1oWCk041oE6oRR7BwMDqbeYMnSCSyQYa3+ed+yoafvE5JKE60x8uta2rZ8tr0UaOlCntaZjlpATBuUP3IwpZ9COmq+v6pucRizoFl2/kNuiyltDhOcdEgZeE4LksL0o9tw0tN89L+sA3Y8m/LiL5mxErv6/c6F9DWFSIWc47zfBc4WwyDyVQNDFrYYrKKV75onIyG2H5wQdKfYsR0GtG9FqIvIq5oqtLFE17+emg50SjEYpmoqELCzmhExODzOoN+r40MAYkPuBA1OaOxYfcy+uJejNgYsUD0+cFHvmq7EekDnkPddRAHYMvRq1jasoNw+DiBgLPdTnYGaDkRwutxCtG/9k3i3FXXYFmKiKGjy58eO36yiI4uP9Oqu4eAw6HjE1m/++pMMTNuUNnk/Hvr6wAzgANIpztdYUPNbF7+U2ZMiVNW5lyGRrqDjCbQzl4fl254iA8+PTMJ4QNTtHPw8dpFyWuAgMhHiKxHvWkRHe6ezp0v3UnrcQ/d3Y54VccHEe3z8M2n7uCD1ulJ+wrqtxG5I13ojK0k+31GfE2IJy3cPcfnUPd8PR9+EqarC/r7R95JuTTRcrKEpU/U88qH56ftGvFhbH3s3oqF7w+5oUkqClFEvmE00GfUlRSTzf622Vz9zGM07Kylrd3Q0+NcjG07d4RUnbFYv+HpN2qZ94u1vHV4dtqeUR+odwciP8sqtp4bXx1u6xJgGxr1o/GsgamlLVxz3iusOPcdpladwuNxLjxDXydaT5WxZd9cnn7zMpraa4aV9iCYwD5gYX31pV1ZrxOeupdzRfVi4AWktwztyxn26pI2zqxspSTgjPfEi2hur+ZoZ1Xu12crCCbwGrCyfvLlnamRFIgbyanAXcD5UPQsmHloDDSRNaG1s4LWzoocS2UYQwCsYhtlDar19VOWJHKeg97rXxxJbxZwA3A/2hdRiY5hv7gwThR2Jl/c9uaaFd+85DSx5uqCyG8QmYL69xpxY2y7sK5+UN+PEVmEyN68PtKfJaSg4hAH6iGwDYkVFA2swDFE1xYav0JBABrBewQxX0hdGfInNAiivwMShRofLTXD09QA/tHnEnTmFmI3XVlFGUPfbAglRjSsXoxooxE9UojN8aQGoAVoNOpdhvbnkUcRiG4c65nkHhqeAttGKFqG9OURqbcFlcZxgIz5SH0RfEcRM/k00VohEG0Yi0gzYk1d1wvvNqoNmKLT9WFKnLGx2Bv2fWSsfTOU2Nki9YFoI6JHx2Trf4gIqB5FtRH8md+sEKhuHLOt9OdNGce1KyVaE1yqdi8YN0b9SbjxNfe47n9p0QZaDK4aTBBUGxi15H6+Yk31hOO8CEw4MWaRfk5iTfUGTKkkRdoyLhuZ1BQevv6Xr/MAU4BKoATw+mp/tc9ue2d/4uAzK4FBoBeIAseAY/7L/6z/D41MAM5JghQDvkTTc3vsE28PAmcnC1kKpBT4DM13FmS3/w4At1jjNg2hxPMAAAAASUVORK5CYII="
            }
        };
    },

    getInitialState: function() {
        this.markersLatLon = [];
        return {
            zoom: this.props.zoom,
            latitude: this.getLatitude(),
            longitude: this.getLongitude(),
            location: this.getLocation(),
            geoQuery: this.props.geoQuery
        };
    },

    getLatitude: function() {
        return this.getLinkValue('latitude');
    },

    getLongitude: function() {
        return this.getLinkValue('longitude');
    },

    getLocation: function() {
        return this.getLinkValue('location');
    },

    getLinkValue: function(name, props) {
        var props = props || this.props,
            value = props[name],
            linkName = name + 'Link';

        if (props[linkName]) {
            value = props[linkName].value;
        }

        return value
    },

    setLinkValue: function(name, value) {
        var props = this.props,
            linkName = name + 'Link';

        if (props[linkName]) {
            props[linkName].requestChange(value);
        }
    },

    render: function() {
        var me = this,
            props = me.props,
            state = me.state,
            show = props.show,
            className = cx(props.wrapperClassName, props.className);

        return (
           React.createElement("div", React.__spread({ref: "map", className: className, "aria-disabled": props.disabled},  _.omit(props, 'className', 'collection', 'id')), 
                state.error && (
                    React.createElement(BS.Alert, {bsStyle: "error", onDismissClick: this.dismissError}, 
                        state.error
                    )
                ), 
                React.createElement("div", {id: props.id, className: "widget-map"}), 
                React.createElement("input", {type: "hidden", name:  props.id + 'longitude', value: state.longitude}), 
                React.createElement("input", {type: "hidden", name:  props.id + 'latitude', value: state.latitude}), 
                React.createElement("input", {type: "hidden", name:  props.id + 'mapZoomLevel', value: state.zoom}), 
                this.props.children
            )
        );
    },

    dismissError: function() {
        this.setState({
            error: undefined
        });
    },

    componentWillReceiveProps: function(nextProps) {
        if (nextProps.monitorResize !== this.props.monitorResize) {
            this.setMonitorResize(nextProps.monitorResize);
        }
        if (nextProps.collection !== this.props.collection) {
            this.updateCollectionEvents(nextProps.collection);
        }
        if (nextProps.geoQuery !== this.state.geoQuery) {
            // this.checkGeoQuery(nextProps);
            this.setState({
                geoQuery: nextProps.geoQuery
            });
        }
        if (this.getLatitude(nextProps) !== this.state.latitude) {
            this.setState({
                latitude: this.getLatitude(nextProps)
            });
        }

        if (this.getLongitude(nextProps) !== this.state.longitude) {
            this.setState({
                longitude: this.getLongitude(nextProps)
            });
        }

        if (this.props.zoom !== nextProps.zoom) {
            this.setState({
                zoom: nextProps.zoom
            });
        }
    },

    updateCollectionEvents: function(collection) {
        if (this.props.collection) {
            this.props.collection.off('sync', this.updateMarkers);
        }
        if (collection) {
            collection.on('sync', this.updateMarkers);
        }
    },

    componentDidMount: function() {
        var me = this,
            props = this.props,
            state = this.state,
            mapId = props.id;
        L.mapbox.accessToken = 'pk.eyJ1Ijoiamhvbm5hdGFuIiwiYSI6IkRYY3llX28ifQ._Gc34jOa_rgGrmN52SkXjA';
        this.map = L.mapbox.map(mapId, 'jhonnatan.kb3do0bd', {
            minZoom: 2,
            maxZoom: 15,
            zoom: state.zoom
        });

        if (state.latitude && state.longitude) {
            this.setView([state.latitude, state.longitude], state.zoom);
        } else if (state.zoom) {
            this.setZoom(state.zoom);
        }

        this.invalidateSize();

        this.addRemoveEvents();

        $(window).on('resize', this.invalidateSize);

        if (state.geoQuery) {
            this.setGeoQuery(state.geoQuery);
        }

        this.updateCollectionEvents(this.props.collection);
        this.handleReadOnly();
        this.updateMarkers();

        if (props.markCenter) {
            this.markCenter();
        }
    },

    addRemoveEvents: function(pP) {
        var me = this;

        if (me.props.readOnly) {
            me.map.off('moveend', me.updateStatePosition);
        } else if (!pP || pP.readOnly !== me.props.readOnly) {
            me.map.on('moveend', me.updateStatePosition);
        }
    },

    setGeoQuery: function(geoQuery) {
        var me = this;

        if (!geoQuery) {
            return;
        }

        if (!me.geocoder) {
            me.geocoder = L.mapbox.geocoder('mapbox.places');
        }

        me.geocoder.query(geoQuery, function(err, data) {
            var center,
                lat, lng;

            if (err) {
                me.setState({
                    error: 'Could not locate ' + geoQuery
                });
            } else if (data && data.lbounds) {
                me.map.fitBounds(data.lbounds);
                center = me.map.getCenter();
                lat = center.lat;
                lng = center.lng;
            } else if (data && data.latlng) {
                lat = data.latlng[0];
                lng = data.latlng[1];
            }

            if (lat && lng) {
                me.setState({
                    latitude: me.formatLatLng(lat),
                    longitude: me.formatLatLng(lng)
                });
            }
        });
    },

    setReverseGeoQuery: function(geoQuery) {
        var me = this,
            location = me.getLocation();

        if (!geoQuery) {
            return;
        }

        if (!me.geocoder) {
            me.geocoder = L.mapbox.geocoder('mapbox.places');
        }

        me.geocoder.reverseQuery(geoQuery, function(err, data) {
            var city, state, country, place, names = [],
                features = data && data.features && data.features.length > 0 ? data.features : undefined;

            if (err) {
                me.setState({
                    error: 'Could not locate ' + geoQuery
                });
            } else if (features) {
                for (var i = 0, len = features.length; i < len; i++) {
                    if (features[i].id.indexOf('place.') === 0) {
                        place = features[i];
                        names = place.place_name.split(', ');
                        break;
                    }
                }
            }

            city = names[0];
            state = names[1];
            country = names[2];

            if (names && names.length === 3 && (!location || location.city.name !== city || location.city.state.name !== state || location.city.country.name !== country)) {
                me.setState({
                    location: {
                        address1: '',
                        city: {
                            id: null,
                            byName: true,
                            name: city,
                            state: {
                                id: null,
                                name: state
                            },
                            country: {
                                id: null,
                                name: country
                            }
                        }
                    }
                });

                console.log('reverseQuery', geoQuery, err, data, city, state, country);
            }
        });
    },

    formatLatLng: function(value) {
        if (value) {
            value = parseFloat(parseFloat(value).toFixed(this.props.precision));
        }

        return value;
    },

    updateStatePosition: function(e) {
        var me = this,
            center = e.target.getCenter(),
            zoom = e.target.getZoom(),
            lat = me.formatLatLng(center.lat),
            long = me.formatLatLng(center.lng),
            state = this.state;

        if (state.latitude !== lat || state.longitude !== long || zoom !== state.zoom) {
            me.setState({
                latitude: lat,
                longitude: long,
                zoom: zoom
            }, function() {
                if (me.props.onPositionChange) {
                    me.props.onPositionChange(latitude, longitude, zoom);
                }
            });
        }
    },


    componentWillUnmount: function() {
        $(window).off('resize', this.invalidateSize);
        this.removeMarkers();
        this.map.remove();
        this.updateCollectionEvents();
    },

    updateMarkers: function(modelThatSynced) {
        var me = this,
            props = me.props,
            model = props.model,
            projects = props.collection,
            map = me.map,
            geoJson = [],
            markersLatLon = this.markersLatLon,
            pinLayer;

        if (modelThatSynced && projects.indexOf(modelThatSynced) !== -1) {
            // [AS-935] - clicking a listing on map throws JS error
            // No need to update markers based off of a model sync event. 
            // We only care about the collection sync event.
            return;
        }

        me.removeMarkers();

        projects && projects.each(function(project) {
            var geoPosition = project.get('geoPosition'),
                markerImage = props.markers[project.hasServiceType('AGENT_PORTAL') ? 'LEVEL3' : 'LEVEL1'] || props.markers.LEVEL1;

            if (geoPosition && geoPosition.latitude !== undefined && geoPosition.longitude !== undefined) {
                geoJson.push({
                    type: 'Feature',
                    "geometry": {
                        "type": "Point",
                        "coordinates": [geoPosition.longitude, geoPosition.latitude]
                    },
                    "properties": {
                        "icon": {
                            "iconUrl": markerImage,
                            "iconSize": [34, 49], // size of the icon
                            "iconAnchor": [17, 49], // point of the icon which will correspond to marker's location
                            "popupAnchor": [140, -15] // point from which the popup should open relative to the iconAncho
                        },
                        "project": project
                    }
                });
                markersLatLon.push(L.latLng(geoPosition.latitude, geoPosition.longitude));
            }
        });

        pinLayer = L.mapbox.featureLayer();
        pinLayer.on('layeradd', function(e) {
            var marker = e.layer,
                feature = marker.feature,
                project = feature.properties.project;

            marker.setIcon(L.icon(feature.properties.icon));
            marker.bindPopup(me.buildPopup(project), {
                closeButton: false
            });
        });

        me.pinLayer = pinLayer.setGeoJSON(geoJson);
        if (props.useClusters) {
            this.clusterGroup = new L.MarkerClusterGroup({
                // The iconCreateFunction takes the cluster as an argument and returns
                // an icon that represents it. We use L.mapbox.marker.icon in this
                // example, but you could also use L.icon or L.divIcon.
                // iconCreateFunction: function(cluster) {
                //     return L.divIcon({
                //         "iconSize": [34, 49],
                //         "iconAnchor": [17, 49], // point of the icon which will correspond to marker's location
                //         "className": "widget-cluster-icon",
                //         // show the number of markers in the cluster on the icon.
                //         "html": "<span>" + cluster.getChildCount() + "</span>"
                //     });
                // },
                polygonOptions: {
                    fillColor: '#3498db',
                    color: '#2980b9',
                    weight: 2,
                    opacity: 0.5,
                    fillOpacity: 0.2
                }
            });
            this.clusterGroup.addLayer(me.pinLayer);
            this.map.addLayer(this.clusterGroup);
        } else {
            pinLayer.addTo(map)
        }
        pinLayer.on('mouseover', function(e) {
            e.layer.openPopup();
        });
        pinLayer.on('mouseout', function(e) {
            e.layer.closePopup();
        });
        pinLayer.on('click', function(e) {
            var marker = e.layer,
                feature = marker.feature,
                project = feature.properties.project;

            if (me.props.onMarkerClick) {
                me.props.onMarkerClick(e, project);
            }
        });
    },

    getLatLongBounds: function() {
        var props = this.props,
            model = props.model,
            markersLatLon = this.markersLatLon,
            markerBounds;

        if (markersLatLon.length > 0) {
            markerBounds = L.latLngBounds(markersLatLon[0]);
            _.each(markersLatLon, function(latLng) {
                markerBounds.extend(latLng);
            });
        } else {
            markerBounds = L.latLngBounds(L.latLng(this.state.latitude, this.state.longitude), L.latLng(this.state.latitude, this.state.longitude));
        }

        return markerBounds;
    },

    removeMarkers: function() {
        var props = this.props,
            map = this.map;

        if (props.useClusters && this.clusterGroup) {
            this.clusterGroup.removeLayer(this.pinLayer);
            map.removeLayer(this.clusterGroup);
        }

        if (this.pinLayer) {
            map.removeLayer(this.pinLayer);
            this.pinLayer = undefined;
        }


        this.markersLatLon.length = 0;
    },

    buildPopup: function(project) {
        var name = project.get('name'),
            image = project.get('image'),
            popup = [
                '<div class="map-popup" style="width:230px;">',
                '   ', (image ? '<img src="' + image + '">' : '<div class="no-image">X</div>'),
                '   <span>', name, '</span>',
                '</div>'
            ].join('');

        return popup;
    },

    centerMap: function(latLong, zoom) {
        var me = this,
            bounds,
            center;

        if (latLong) {
            this.setState({
                latitude: me.formatLatLng(latLong[0] || this.state.latitude),
                longitude: me.formatLatLng(latLong[1] || this.state.longitude)
            });
        } else {
            bounds = this.getLatLongBounds();
            if (bounds) {
                this.map.fitBounds(this.getLatLongBounds(), {
                    paddingTopLeft: [0, 20]
                });
                center = this.map.getCenter();
                this.setState({
                    latitude: me.formatLatLng(center.lat),
                    longitude: me.formatLatLng(center.lng)
                });
            }
        }

        if (zoom) {
            this.setZoom(zoom);
        }
    },

    setView: function(latLong, zoom) {
        var me = this;

        if (!me.props.readOnly) {
            me.map.off('moveend', me.updateStatePosition);
        }

        me.map.setView(latLong, zoom, {
            animate: false
        });

        if (!me.props.readOnly) {
            me.map.on('moveend', me.updateStatePosition);
        }
    },

    componentDidUpdate: function(pP, pS) {
        var s = this.state,
            p = this.props,
            dGeoPosition = p.defaultGeoPosition,
            updatedLatOrLong = false;

        if (pS.latitude !== s.latitude || pS.longitude !== s.longitude) {
            if(s.latitude && s.longitude) {
                this.setView([s.latitude, s.longitude], s.zoom);
            }

            if (p.updateLatLong && s.latitude !== pS.latitude || p.updateLatLong !== pP.updateLatLong) {
                this.setLinkValue('latitude', s.latitude);
                updatedLatOrLong = true;
            }

            if (p.updateLatLong && s.longitude !== pS.longitude || p.updateLatLong !== pP.updateLatLong) {
                this.setLinkValue('longitude', s.longitude);
                updatedLatOrLong = true;
            }

            if (p.markCenter) {
                this.markCenter();
            }
        } else if (pS.zoom !== s.zoom) {
            this.setZoom(s.zoom);
        }

        if (pS.geoQuery !== s.geoQuery) {
            this.setGeoQuery(s.geoQuery);
        }

        if (p.reverseGeoQuery !== false && updatedLatOrLong && p.updateLocation && (!dGeoPosition || dGeoPosition.latitude !== s.latitude || dGeoPosition.longitude !== s.longitude) && (s.longitude !== pS.longitude || s.latitude !== pS.latitude)) {
            this.setReverseGeoQuery([s.longitude, s.latitude]);
        }

        if (p.updateLocation && s.location.city.name && s.location.city.state.name && s.location.city.country.name && (s.location !== pS.location || p.updateLocation !== pP.updateLocation)) {
            this.setLinkValue('location', s.location);
        }

        this.handleReadOnly();
        this.addRemoveEvents(pP);

        if (p['aria-hidden'] !== pP['aria-hidden']) {
            this.invalidateSize();
        }
    },

    setZoom: function(zoom) {
        this.map.setZoom(zoom);
    },

    getZoom: function() {
        return this.map.getZoom();
    },

    invalidateSize: function() {
        if (this.isMounted()) {
            this.map.off('moveend', this.updateStatePosition);
            this.map.invalidateSize();
            this.addRemoveEvents();
        }
    },

    handleReadOnly: function() {
        var readOnly = this.props.readOnly || this.props.disabled,
            map = this.map;

        if (readOnly) {
            // Disable drag and zoom handlers.
            map.dragging.disable();
            map.touchZoom.disable();
            map.doubleClickZoom.disable();
            map.scrollWheelZoom.disable();
            if (map.zoomControl._map) {
                map.removeControl(map.zoomControl);
            }
        } else {
            map.dragging.enable();
            map.touchZoom.enable();
            map.doubleClickZoom.enable();
            map.scrollWheelZoom.enable();
            if (!map.zoomControl._map) {
                map.addControl(map.zoomControl);
            }
        }
    },

    markCenter: function() {
        var me = this,
            props = me.props,
            state = me.state,
            map = me.map,
            marker = {
                type: 'Feature',
                "geometry": {
                    "type": "Point",
                    "coordinates": [state.longitude, state.latitude]
                }
            },
            pinLayer;

        if (me.centerPinLayer) {
            map.removeLayer(me.centerPinLayer);
            me.centerPinLayer = undefined;
        }

        if (state.longitude && state.longitude) {
            pinLayer = L.mapbox.featureLayer().addTo(map);
            me.centerPinLayer = pinLayer.setGeoJSON([marker]);
        }
    }
});

module.exports = ProjectsMap;
